import { linearTiming } from "@remotion/transitions";
import { TransitionKind, TransitionSpeed } from "@repo/api/transition";
import { msToFrames } from "../../utils/timing.ts";
import {
  getDefaultPreviewClipDurationsInFrames,
  ImageTransitionBuilder,
  ImageTransitionBuilderProps,
} from "./ImageTransitionBuilder.ts";
import { glitchCut, GlitchCutProps } from "../remocn/glitch-cut.tsx";

const transitionKind = TransitionKind.enum.GLITCH_CUT;

// NORMAL matches remocn's recommended 12 frames @ 30fps; past ~20 frames the
// tearing stops reading as a cut.
const GLITCH_CUT_DURATION_MS: Record<TransitionSpeed, number> = {
  SLOW: 600,
  NORMAL: 400,
  FAST: 300,
};

function getGlitchCutDurationInFrames(props: ImageTransitionBuilderProps) {
  return msToFrames(
    GLITCH_CUT_DURATION_MS[props.imageTransition.speed ?? "NORMAL"],
    props.fps,
  );
}

export const ImageGlitchCutTransitionBuilder: ImageTransitionBuilder<GlitchCutProps> =
  {
    formConfig: {
      kind: transitionKind,
      buildDefaultValue: () => ({ kind: transitionKind, speed: "NORMAL" }),
      speed: ["SLOW", "NORMAL", "FAST"],
    },

    transition: {
      getDurationInFrames: getGlitchCutDurationInFrames,
      buildPresentation: () => glitchCut(),
      buildTiming: (props) =>
        linearTiming({ durationInFrames: getGlitchCutDurationInFrames(props) }),
    },

    getPreviewClipDurationsInFrames: getDefaultPreviewClipDurationsInFrames,
  };
